module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-3.6acf910e.jpg";